import React, { useEffect, useRef, useState } from "react";
import { MoreVertical, Trash } from "react-feather";

import { LabeledInput, LabeledSelect } from "@/Components/Form";
import { GAS_OPTIONS } from "@/Enums/gas_options";
import { SCOPE_OPTIONS } from "@/Enums/scopes";
import { ActionMenu } from "@/Components/ActionMenu";
import { FactorGasComment } from "@/Components/EmissionFactors/FactorGasComment";

export function FactorGas({
  children,
  className = "",
  index = 0,
  gas = {},
  unit = "",
  isDisabled = false,
  onRemove = () => {},
  onFormUpdate = () => {},
  errors = {},
}) {
  const [isEditable, setIsEditable] = useState(!isDisabled);
  const [data, setData] = useState(gas || {});
  const [commentVisible, setCommentVisible] = useState(!!gas?.comment);

  function removeGas() {
    setIsEditable(true);
    // Is it a bit too easy to remove a gas?
    // if (confirm("Are you sure you want to remove this gas?")) {
    onRemove(index, data);
    // }
    setIsEditable(false);
  }

  function handleUpdate(e) {
    const { name, value } = e.target;
    // gas[name] = value;
    setData({
      ...data,
      [name]: value,
    });

    onFormUpdate(index, { name, value }, gas?.id || null);
  }

  const gasOptions = [
    {
      label: "CO₂e",
      value: "co2e",
    },
    ...GAS_OPTIONS,
  ];

  const actionMenuItems = [
    {
      label: "Delete",
      callback: () => removeGas(),
    },
  ];

  if (!commentVisible) {
    actionMenuItems.unshift({
      label: "Add comment",
      callback: () => {
        setCommentVisible(true);
      },
    });
  }

  const actionMenuRef = useRef(null);

  return (
    <div className={`relative overflow-visible ${className}`}>
      <div className="mb-4 flex w-full flex-col flex-wrap justify-between gap-2 border-l-4 border-borderColor pl-6 md:flex-row md:items-center">
        <LabeledSelect
          disabled={!isEditable}
          name="gas"
          value={data.gas}
          containerClass="w-auto md:w-20 grow"
          title="Impact category*"
          options={gasOptions}
          defaultOption={"Select"}
          onChange={handleUpdate}
          required={true}
          error={errors?.[`gases.${index}.gas`]}
        />
        <LabeledInput
          disabled={!isEditable}
          name="factor"
          value={data.factor}
          containerClass="w-auto md:w-20 grow"
          type="number"
          title="Amount*"
          placeholder="0"
          unit={`kg/${unit || "unit"}`}
          onChange={handleUpdate}
          required={true}
          error={errors?.[`gases.${index}.factor`]}
        />
        <LabeledSelect
          disabled={!isEditable}
          name="scope"
          value={data.scope}
          containerClass="w-auto md:w-20 grow"
          title="Scope / LCA stage*"
          options={SCOPE_OPTIONS}
          onChange={handleUpdate}
          defaultOption={"Select scope"}
          required={true}
          error={errors?.[`gases.${index}.scope`]}
        />
        {isEditable && (
          <div className="-order-1 flex flex-col justify-center self-end md:-order-none md:self-auto">
            <div
              className="hover-circle relative z-10 ml-2 h-6 w-6 md:mt-6"
              onClick={(e) => {
                e.preventDefault();
                actionMenuRef.current.toggleMenu();
              }}
            >
              <MoreVertical size={24} className="shrink-0 cursor-pointer" />
              <ActionMenu ref={actionMenuRef} items={actionMenuItems} />
            </div>
          </div>
        )}
        {commentVisible && (
          <FactorGasComment
            gas={gas}
            isDisabled={!isEditable}
            onFormUpdate={handleUpdate}
            setCommentVisible={setCommentVisible}
          />
        )}
      </div>
      {children}
    </div>
  );
}
